export const environment = {
    production: true,
    versi_app: 3,

    apiURL: 'https://api.salaree.id',
    goApiURL: 'https://api-go.humanis.id/api/v1',
    // apiURL: 'https://humanis-api.venturo.pro',
    imageURL: 'https://storage.googleapis.com/vstorage-humanis/assets/img/',
    projectURL: 'salaree',
    
    firebaseConfig: {
       apiKey: 'AIzaSyDPtnERtJfy7iNCmoT661-rRgkrRdfyDPY',
       authDomain: 'humanis-2020.firebaseapp.com',
       databaseURL: 'https://humanis-2020.firebaseio.com',
       projectId: 'humanis-2020',
       storageBucket: 'humanis-2020.appspot.com',
       messagingSenderId: '426951655222',
       appId: '1:426951655222:web:5373aa328f1a45ca6d3d97',
       measurementId: 'G-B9XTTKCW55'
    }
};
